import { useEffect } from 'react'

declare global {
  interface Window {
    ADRUM: any
  }
}

export const useAdrum = (enableUnmount?: boolean) => {
  const startADRUMTagging = (tag: string) => {
    if (window.ADRUM !== undefined) {
      window.ADRUM.markVirtualPageBegin(tag, true)
    }
  }

  const endADRUMTagging = () => {
    if (window.ADRUM !== undefined) {
      window.ADRUM.markVirtualPageEnd()
    }
  }

  useEffect(
    () => () => {
      if (enableUnmount) {
        endADRUMTagging()
      }
    },
    [enableUnmount],
  )

  return {
    startADRUMTagging,
    endADRUMTagging,
  }
}
